export default {
  id: null,
  codigo: null,
  nome: null,
  tipoAcessoProduto: null,
  inative: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/productmodel.js